// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchInput_searchInput__CromA","shimmer":"SearchInput_shimmer__mKJKE"};